import {Pipe, PipeTransform} from '@angular/core';
import {Occupancy} from '../../shared/interfaces/occupancy';

@Pipe({
  name: 'occupancy'
})

export class OccupancyPipe implements PipeTransform {

  createOccupancyString(value: Occupancy): string {

    if (value.guests <= 1) {
      return `${value.guests} Viaggiatore`;
    }
    return `${value.guests} Viaggiatori`;
  }

  transform(value: Occupancy, ...triggers: any[]): string {
    return value ? this.createOccupancyString(value) : '';
  }

}
